import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { GetOrganizationChecklistDto } from '../../../../../../../../aumico-lib-users-fe/src/public-api';
import { FileMetadataService } from '../../../services/documents.service';
import { FileMetadataDto } from '../../dto/file-metadata.dto';

@Injectable({ providedIn: 'root' })
export class FinancialClosingProcessService extends FileMetadataService {
    private readonly checklists = 'checklists';
    private readonly uploadFcpDocument = 'upload';
    private readonly encrypt = 'encrypt';

    uploadFinancialClosingProcessDocument$(documentFile: FormData | null): Observable<FileMetadataDto> {
        const url = `${this.apiGatewayUrl}${this.fileMetadata}/${this.uploadFcpDocument}/${this.encrypt}`;

        return this.http.patch<FileMetadataDto>(url, documentFile);
    }

    getFcpChecklists$(): Observable<GetOrganizationChecklistDto[]> {
        return this.http.get<GetOrganizationChecklistDto[]>(`${this.apiGatewayUrl}${this.checklists}/fcp`);
    }
}
